import React from 'react';

import { StyledInfoCard, Title, Value } from './InfoCard.styles';

function InfoCard({ title, hasbg, value, fontbase, center, ...props }) {
  return (
    <StyledInfoCard hasbg={hasbg} {...props}>
      <Title fontbase={fontbase}>{title}&nbsp;:&nbsp;</Title>
      <Value fontbase={fontbase}>{value}</Value>
    </StyledInfoCard>
  );
}

export default InfoCard;
